<template>
  <div class="contain">
    <div class="recordBox comStyBox">
      <yNavBar title="咨询详情" />
      <div class="contentbox">
        <div class="title">{{ newData.newsName }}</div>
        <div class="time">
          {{ newData.upTime }}
        </div>
        <div
          v-if="newData.readType !== 'READ_V'"
          v-html="newData.neiRong"
        ></div>
        <div v-if="newData.readType === 'READ_V'" class="videobox"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getYaxNewsInfo } from "@/api/index";
export default {
  data() {
    return {
      newData: "",
      pageData: this.$route.params.data,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var reqData = {
        newsId: this.pageData.newsId,
      };
      getYaxNewsInfo(reqData).then((res) => {
        if (res.data.state === 0) {
          this.newData = res.data.data;
        }
      });
    },
  },
  components: {},
  computed: {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.contentbox {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  padding: 21px;
  box-sizing: border-box;

  .title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
  }

  .time {
    font-weight: 500;
    font-size: 14px;
    color: #b9b4b4;
    line-height: 16px;
    padding: 16px 0;
    box-sizing: border-box;
  }
}

.videobox {
  width: 100%;
}

video {
  width: 100%;
}
</style>
